import axios from 'axios';
import { getLoginToken, isLogged, removeLoginToken } from '../helpers/authorizationToken'
import toast from '../helpers/toast';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use((config) => {
  const token = getLoginToken();
  if (token && config.headers && !config.noAuth) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const errorData =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.response?.data?.['hydra:description'] ||
      error?.response?.data?.violations?.[0]?.message ||
      'Unknown error';

    const status = error?.response?.status;
    const isExpiredJwt =
      status === 403 && error?.response?.data?.message === 'Expired JWT Token';
    const isAuthError = status === 401 || isExpiredJwt;
    const isNoAuthRequest = Boolean(error?.config?.noAuth);

    // IMPORTANT:
    // Never hard-redirect/reload from the interceptor.
    // It wipes UI state (e.g. login errors) and makes behavior depend on
    // whichever request hits a 401 first.
    //
    // Instead, clear the token; the app should react to `isLogged()` becoming false.
    if (isAuthError && isLogged() && !isNoAuthRequest) {
      removeLoginToken();
    }

    if (!error?.config?.skipGlobalErrorToast) {
      toast.error(errorData);
    }
    return Promise.reject(error);

  }
);

export default api;
